export default __webpack_public_path__ + "static/media/cley.17b0f488.jpg";